import React from 'react';
import PropTypes from 'prop-types';

import './PlotStats.css';

export default function PlotStats({
  avg, color, ev, data, isActive, setActive, timestamp, unit, hasData = true, showAvg = false,
}) {
  return (
    <div className="plot-stats flex-col" role="presentation">
      <div className="btu-hr line" style={{ color }}>{data || 0}</div>
      {(showAvg || avg) ? (
        <div className="line">{`Avg: ${avg || 'N/A'} ${avg ? unit : ''}`}</div>
      ) : null}
      {hasData ? <div className="line">{`As of: ${timestamp || 'N/A'}`}</div> : null}
      <div className="ev flex-row line">
        <div
          role="presentation"
          className={`circle ${isActive ? 'active' : ''}`}
          style={{ background: color }}
          onClick={() => setActive(!isActive)}
        />
        {ev}
      </div>
    </div>
  );
}

PlotStats.propTypes = {
  avg: PropTypes.string,
  color: PropTypes.string,
  data: PropTypes.any,
  ev: PropTypes.string,
  isActive: PropTypes.bool,
  setActive: PropTypes.func,
  timestamp: PropTypes.string,
  unit: PropTypes.string,
  hasData: PropTypes.bool,
  showAvg: PropTypes.bool,
};
